module.exports = __webpack_public_path__ + "static/media/7_RoomControls_BedShades_HL.7ed13349.png";